import React from 'react';
import styles from './ApproverInfo.module.scss';
import { useTranslation } from 'react-i18next';

const ApproverInfo = ({ img = '', fullName = ' ' }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.line} />
      <div className={styles.infoContainer}>
        <div className={styles.imageContainer}>
          {img ? <img className={styles.image} src={img} alt={t('clip_organizer.add_modal.avatar')} /> : <span>{fullName[0].toUpperCase()}</span>}
        </div>
        <div className={styles.approverNameContainer}>
          <span className={styles.title}>{t('approvals.approver')}</span>
          <span className={styles.approverName}>
            {t('approvals.approver.by')} {fullName}
          </span>
        </div>
      </div>
      <div className={styles.line} />
    </div>
  );
};

export default ApproverInfo;
